//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProd', {
//        templateUrl: 'views/components/views/discGrpProd/discGrpProd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'discGrpProdService', 'economyService', function ($stateParams, stateService, modalService, translateService, discGrpProdService, economyService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpProdKeyno = $stateParams.discgrpprod_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                discGroupProductNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('discgrpprodlangs', { discgrpprod_keyno: vm.model.edit.discgrpprod_keyno }) }
//                ],
//                edit: {},
//                selectListPriceMethods: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await discGrpProdService.getEdit({ discgrpprod_keyno: discGrpProdKeyno }))[0];
//            }

//            async function loadPriceMethods() {
//                vm.model.selectListPriceMethods = await economyService.listPriceMethods();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                discGrpProdService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadPriceMethods();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
